import { memo } from 'react';

import { CgCrown } from 'react-icons/cg';

import { useEventfy, useGamificationQuery } from '@hooks';
import { selectIsGamificationRankingEnabled } from '@hooks/useEventfy/selectors';

import RankingCard from './RankingCard';
import BannerCarousel from '../BannerCarousel';
import * as S from '../styles';

const Sidebar = () => {
  const isGamificationEnabled = useEventfy(selectIsGamificationRankingEnabled);

  const gamificationQuery = useGamificationQuery();

  const rankings = gamificationQuery.data?.slice(0, 3) ?? [];
  const showRankingEmpty = gamificationQuery.isSuccess && rankings.length === 0;

  return (
    <S.Container>
      <BannerCarousel side="left" />

      {isGamificationEnabled && (
        <S.RankingSection>
          <S.PanelCardHeader>
            <h3>Top 3 Usuários</h3>
          </S.PanelCardHeader>

          {showRankingEmpty ? (
            <S.SidebarEmptyState>
              <CgCrown size={34} />
              <strong>Nenhum ranking por enquanto</strong>
              <span>
                Participe de atividades e eventos para conquistar sua posição.
              </span>
            </S.SidebarEmptyState>
          ) : (
            <ul>
              {rankings.map((ranking, index) => (
                <RankingCard
                  key={`ranking-${ranking.user_id}`}
                  position={index + 1}
                  {...ranking}
                />
              ))}
            </ul>
          )}
        </S.RankingSection>
      )}
    </S.Container>
  );
};

export default memo(Sidebar);
